import {
  CalendarMinusIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { FilterButton } from "@/components/FilterButton/FilterButton";
import { ReservationType } from "@/features/bookings/types/types";

import { reservationTypesLabels } from "./labels";

const iconMap: Record<ReservationType, React.ElementType> = {
  [ReservationType.REFUNDED]: XCircleIcon,
  [ReservationType.PAST]: CheckCircleIcon,
  [ReservationType.UPCOMING]: CalendarMinusIcon,
};

const orderedTypes = [
  ReservationType.UPCOMING,
  ReservationType.PAST,
  ReservationType.REFUNDED,
] as const;

type Props = {
  value: ReservationType;
  onValueChange: (value: ReservationType) => void;
};

export const ReservationTypeFilter = ({ value, onValueChange }: Props) => {
  const intl = useIntl();

  return (
    <div
      role="radiogroup"
      aria-label={intl.formatMessage({
        defaultMessage: "Booking status",
        description:
          "Accessible label for the booking status filter (Cancelled / Completed / Upcoming)",
      })}
      className="mb-4 flex w-full gap-2"
    >
      {orderedTypes.map((type) => {
        const Icon = iconMap[type];
        return (
          <div key={type} className="flex-1">
            <FilterButton
              role="radio"
              aria-checked={value === type}
              fullWidth
              active={value === type}
              onClick={() => onValueChange(type)}
            >
              <Icon size={20} className="shrink-0" />
              {intl.formatMessage(reservationTypesLabels[type])}
            </FilterButton>
          </div>
        );
      })}
    </div>
  );
};
